<template>
  <div class="caring-nodata">
    <i class="iconfont icon-wushuju"></i>
    <slot name="message">
      <div>暂无相关数据</div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'caringNoData',
  data: function () {
    return {}
  },
  methods: {},
  mounted: function () {}
}
</script>

<style lang="less">
  @import '../../styles/common.less';

  .caring-nodata {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -150px;
    margin-top: -100px;
    width: 300px;
    height: 200px;
    text-align: center;
    color: @disabled-color;
    padding: 20px;

    i.iconfont {
      font-size: 80px;
    }
  }
</style>
